// Travel on the web: destinations (with real photos + flags), live fares, things to do, trips.
import { api, qs } from "@/lib/api";

export const travelApi = {
  destinations: (q = "") => api(`/travel/destinations?${qs({ q })}`, { auth: false }),
  photo: (p) => api(`/travel/photo?${qs(p)}`, { auth: false }),
  experiences: (city, country, surface = "web_travel") => api(`/travel/experiences?${qs({ city, country, surface })}`, { auth: false }),
  homeAirport: () => api("/travel/home-airport"),
  searchAirports: (q) => api(`/geo/airports/search?${qs({ q })}`, { auth: false }),
  flights: (p) => api(`/travel/flights/search?${qs(p)}`),
  trips: () => api("/travel/trips"),
  createTrip: (body) => api("/travel/trips", { method: "POST", body }),
  trip: (id) => api(`/travel/trips/${id}`),
  planDay: (p) => api(`/travel/plan-day?${qs(p)}`),
};

/** Flag image for a country code (flagcdn, no key) — same source the backend returns. */
export const flagUrl = (cc, w = 160) => (cc && /^[a-z]{2}$/i.test(cc) ? `https://flagcdn.com/w${w}/${cc.toLowerCase()}.png` : null);

/** Client-side mirror of travel/experiences.py plain links — used until the backend endpoint is live, and as a fallback. */
export function experienceLinks(city, country) {
  const q = encodeURIComponent(country ? `${city} ${country}` : city);
  const c = encodeURIComponent(city);
  return {
    city, country, any_partner: false,
    disclosure: "Fable+ may earn a commission when you book through a partner link — it never changes your price.",
    items: [
      { key: "getyourguide", label: "GetYourGuide", kind: "Tours & tickets", coverage: "Worldwide · 150k experiences", url: `https://www.getyourguide.com/s/?q=${q}&searchSource=3`, partner: false, rel: "noopener" },
      { key: "viator", label: "Viator", kind: "Tours & day trips", coverage: "Worldwide · Tripadvisor company", url: `https://www.viator.com/searchResults/all?text=${q}`, partner: false, rel: "noopener" },
      { key: "klook", label: "Klook", kind: "Attractions & transport passes", coverage: "Strongest in Asia-Pacific", url: `https://www.klook.com/en-GB/search/result/?query=${q}`, partner: false, rel: "noopener" },
      { key: "tiqets", label: "Tiqets", kind: "Museums & attractions", coverage: "Skip-the-line tickets, Europe & US", url: `https://www.tiqets.com/en/search?q=${c}`, partner: false, rel: "noopener" },
      { key: "civitatis", label: "Civitatis", kind: "Guided tours & free walking tours", coverage: "Europe & Latin America", url: `https://www.civitatis.com/en/search/?q=${c}`, partner: false, rel: "noopener" },
    ],
  };
}

/** One flat field colour per city when no photo has been fetched yet (never a gradient). */
const FIELDS = ["#0A84FF", "#5CE1F5", "#FF5722", "#FFC21A", "#E0127B", "#6D1FE0", "#0E2A32", "#14B8A6", "#F59E0B", "#3B82F6"];
export const fieldFor = (hue = 0) => FIELDS[Math.abs(Number(hue) || 0) % FIELDS.length];

export function fmtTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
}
export function fmtDur(min) {
  if (!min && min !== 0) return "";
  const h = Math.floor(min / 60), m = min % 60;
  return h ? `${h}h ${m ? `${m}m` : ""}`.trim() : `${m}m`;
}
